module.exports = __webpack_public_path__ + "static/client1-e4401433c302a6971178128a692b5070.png";